/**
 * 格式化markdown
 * @param {*} res 
 */
export const filterMarkdownHtml = res => {
    const {
        name,
        content
    } = res
    let softInfos = []
    let stepTitle = []
    let stepInfo = []
    const mdHtml = content.split('<p></p>')
    if (mdHtml.length > 2) {

        // 切割数据
        const stepHtml = mdHtml[2].split(/<h1>|<h2>|<h3>/)
        // const stepHtml = mdHtml[2].split(/<h2>|<h3>/)
        let index = 1
        stepHtml.map(row => {
            if (row) {
                // 先截取出步骤内容项
                const step = row.split(/<\/h1>|<\/h2>|<\/h3>/)
                if (step[1]) {
                    // 判断仿真软件是否存在
                    let stepHtml = step[1]
                    if (stepHtml.indexOf('<soft>') > -1) {
                        const outHtml = stepHtml.split(/<soft>|<\/soft>/)
                        let softInfo
                        outHtml.map(row => {
                            if (row.indexOf('data-code') > -1) {
                                softInfo = row
                                stepHtml = stepHtml.replace(softInfo, '')
                                if (softInfo) {
                                    let softJson = null
                                    if (softInfo.indexOf('data-code="') > -1)
                                        softJson = JSON.parse(softInfo.split(/data-code="|">/)[1].replace(/&quot;/g, '"'))
                                    if (softInfo.indexOf("data-code='") > -1)
                                        softJson = JSON.parse(softInfo.split(/data-code='|'>/)[1].replace(/&#10;/g, ''))
                                    if (softJson) {
                                        Object.assign(softJson, {
                                            step: index
                                        })
                                        softInfos.push(softJson)
                                    }
                                }
                            }
                        })
                    }
                    stepInfo.push(stepHtml)

                    // 再处理标题
                    const title = step[0].split(/<\/a>/)
                    stepTitle.push(title[1])
                    index++
                }
            }
        })
    }
    return {
        name,
        softInfos,
        stepInfo,
        stepTitle,
    }
}
